import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/agent-traces/continual')({
    head: () => ({ meta: [{ title: 'Continual Agent Runs' }] }),
});
